import {ComponentPropsWithoutRef, FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import {Pulldown} from 'jbc-front/components/icons'
import styles from './List.scss'

export const ListHeader = 'h4'
export const List = 'ul'
export const ListItem = 'li'

export const ListArrow: FC = () => (
  <div className={styles.listArrow}>
    <Pulldown size={10} />
  </div>
)

export const AlertItem: FC<ComponentPropsWithoutRef<'p'>> = ({className, children, ...props}) => (
  <p className={classNames(styles.alertLink, className)} {...props}>
    {children}
  </p>
)

export const AlertLink = <T,>({className, ...props}: ComponentPropsWithoutRef<Link<T>>) => (
  <Link className={classNames(styles.alertLink, className)} {...props} />
)

interface IndicatorProps {
  color?: string
}

export const Indicator: FC<IndicatorProps> = ({color = '#f84f31'}) => {
  const definedColorClass = styles[`indicator_${color}`]
  if (definedColorClass) {
    return <div className={classNames(styles.indicator, definedColorClass)} />
  } else {
    return <div className={styles.indicator} style={{backgroundColor: color}} />
  }
}

interface AlertDateProps {
  children: ReactNode
}

export const AlertDate: FC<AlertDateProps> = ({children}) => <span className={styles.alertDate}>{children}</span>

interface StaffCodeProps {
  children: ReactNode
}

export const StaffCode: FC<StaffCodeProps> = ({children}) => <span className={styles.staffCode}>{children}</span>
